import React from 'react';
import { ReactComponent as Icon } from '@meindach/ui-kit/dist/assets/icons/house.svg';
import { ReactComponent as Loading } from '@meindach/ui-kit/dist/assets/loading/loading.svg';
import { LoadingListContainer } from './styled';
import { Title, P } from '@meindach/ui-kit';
import { useTranslation } from 'react-i18next';

export const LoadingOpportunities = () => {
  const { t } = useTranslation('opportunityList');
  return (
    <LoadingListContainer>
      <Icon />
      <Title m>{t('loadingTitle')}</Title>
      <P>{t('loadingText')}</P>
      <Loading />
    </LoadingListContainer>
  );
};
